// TODO - fix component groundup, using the props of StickyHeaderWithCTA

import Button from "@common/buttons/button"
import { Header } from "@common/header/headerUnit"

// cta -> ctaText
// ctaUnit -> Alternate ctaUnit
export default function HeaderWithCTA({
  title,
  renderLhs,
  cta,
  ctaOnClick,
  ctaUnit,
}) {
  return (
    <div className=" flex items-center justify-between ">
      {title && <Header.MainHeader variant="h6">{title}</Header.MainHeader>}
      {renderLhs && renderLhs()}
      {cta && (
        <Button variant="primary" onClick={handleCtaClick}>
          {cta}
        </Button>
      )}
      {ctaUnit ? ctaUnit : null}
    </div>
  )

  function handleCtaClick() {
    if (ctaOnClick) ctaOnClick()
  }
}
